import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import HistoryLogsWrapper from '../history-logs-wrapper';
import { getColorFromKey } from '../../util/helpers';

class LogRenderer extends Component {
  renderComp() {
    const { value, data } = this.props;
    let color = null;
    if (data.close_date_ago) {
      let stage = value;
      if (data.stage) {
        ({ stage } = data);
      }
      color = getColorFromKey(stage);
      return (
        <span style={{ color }}>{stage} {data.close_date_ago}</span>
      );
    }
    color = getColorFromKey(value);
    return <span style={{ color }}>{value}</span>;
  }

  render() {
    const {
      data, field, logField, value,
    } = this.props;
    const isGrouped = this.props.node && this.props.node.group;
    let comp = <span>{value}</span>;
    if (!isGrouped && data && data.opportunity_id) {
      comp = this.renderComp();
      return (
        <div>
          <HistoryLogsWrapper type={(logField || field)} opportunity={data}>
            {comp}
          </HistoryLogsWrapper>
        </div>
      );
    }
    return comp;
  }
}

LogRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(moment),
    PropTypes.shape({
      value: PropTypes.number,
    }),
  ]),
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  field: PropTypes.string.isRequired,
  logField: PropTypes.string,
};
LogRenderer.defaultProps = {
  value: null,
  data: null,
  node: null,
  logField: null,
};

export default LogRenderer;
